
import { Helmet } from "react-helmet-async";
import PageLayout from "@/components/layout/PageLayout";

const DoctoralSchools = () => {
  return (
    <PageLayout>
      <Helmet>
        <title>Écoles Doctorales - FORESTT-HUB</title>
        <meta name="description" content="Informations sur les programmes doctoraux et les écoles doctorales liées au projet FORESTT-HUB." />
      </Helmet>
      
      <section className="py-16">
        <div className="container">
          <h1 className="mb-8 text-center text-4xl font-bold md:text-5xl text-ecofor-dark-green">
            Écoles Doctorales
          </h1>
          
          <div className="max-w-3xl mx-auto">
            <p className="text-lg mb-8">
              Le projet-ciblé FORESTT-HUB soutient plusieurs programmes doctoraux et collabore étroitement avec des écoles doctorales à travers la France et l'Europe.
            </p>

            {/* Contenu de la page des écoles doctorales */}
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default DoctoralSchools;
